// TODO move this higher up.  maybe RequetsStatus?
export enum PostStatus {
  IN_PROGRESS = 'in-progress',
  SUCCESS = 'success',
  FAILURE = 'failure',
}
